import { render, staticRenderFns } from "./CertificateGraphWrapper.vue?vue&type=template&id=a81e31d2&scoped=true&"
import script from "./CertificateGraphWrapper.vue?vue&type=script&lang=ts&"
export * from "./CertificateGraphWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81e31d2",
  null
  
)

export default component.exports